import { useContext } from 'react'
import { Page, Container, LogoContainer, ContentContainer, Title, Paragraph } from '@/styles/page.styles'
import svgs from '@/constants/svgs'

import { StoreContext } from '@/components/App'
import { observer } from 'mobx-react'
import { getQueryVariable } from '@/methods/getWindowLocationData'

export const ErrorPage = observer(() => {
  const store = useContext(StoreContext)
  const { theme, themeId } = store.AppState

  const errorText =
    getQueryVariable('error') ||
    'It seems that the data associated with your email address does not match the data from the identity verification process.'

  return (
    <Page {...theme.app}>
      <Container {...theme.container}>
        {theme.infoPage.$showAboveTitle && (
          <LogoContainer>
            {theme.logo.$svg && (
              <div>
                <img src={theme.logo.$svg} />
              </div>
            )}
            {svgs[themeId].error ? (
              <div>
                <img src={svgs[themeId].error} />
              </div>
            ) : (
              <div className={'empty'} />
            )}
          </LogoContainer>
        )}

        <ContentContainer {...theme.container}>
          <Title {...theme.title}>Error</Title>
          {svgs[themeId].error && !theme.infoPage.$showAboveTitle && (
            <LogoContainer>
              <img src={svgs[themeId].error} />
            </LogoContainer>
          )}
          <Paragraph {...theme.paragraph}>{errorText}</Paragraph>
          <Paragraph {...theme.paragraph}>Contact your domain administrator to get help:</Paragraph>
          <Paragraph {...theme.paragraph}>john.smith@example.com</Paragraph>
        </ContentContainer>
      </Container>
    </Page>
  )
})
